import deserialize from 'app/utils/deserialize'
import { fetch, update } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    list: [],
    item: null
  },

  getters: {
    currentInvoices: (state) => state.list,
    currentInvoice: (state) => state.item
  },

  mutations: {
    invoicesFetched(state, { invoices }) {
      state.list = invoices
    },

    invoiceFetched(state, { invoice }) {
      state.item = invoice
    },

    invoiceUpdated(state, { invoice }) {
      state.item = invoice
    },

    resetState(state) {
      state.list = []
      state.item = null
    }
  },

  actions: {
    fetchInvoices({ commit }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/invoices`
        })
          .then((response) => {
            deserialize(response.data).then((invoices) => {
              commit('invoicesFetched', { invoices })
              resolve()
            })
          })
          .catch((_error) => {
            reject()
          })
      })
    },

    fetchInvoice({ commit }, invoiceId) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/invoices/${invoiceId}`
        })
          .then((response) => {
            deserialize(response.data).then((invoice) => {
              commit('invoiceFetched', { invoice })
              resolve()
            })
          })
          .catch((_error) => {
            reject()
          })
      })
    },

    updateBuyerDetails({ commit, state }, { buyerDetails }) {
      return new Promise((resolve, reject) => {
        update({
          url: `/api/invoices/${state.item.id}`,
          type: 'invoice',
          changes: {
            buyerDetails
          },
          record: state.item
        })
          .then((response) => {
            deserialize(response.data).then((invoice) => {
              commit('invoiceUpdated', { invoice })
              resolve()
            })
          })
          .catch((_error) => {
            reject()
          })
      })
    }
  }
}
